export const REMOVE_USER_FROM_WORKSPACE_NAME = "remove_user_from_workspace";
export const REMOVE_USER_FROM_WORKSPACE_DESC = `Removes a user from a workspace using the GraphQL removeUserFromOrganization mutation.

Use when the user explicitly asks to remove a member from a workspace.
This is a destructive membership change, so it must go through native tool approval.

Input:
- 'organizationId' (required): Target workspace/organization ID.
- 'email' (required): Email address of the member to remove.

Output:
- Returns the target organizationId/email and whether removal succeeded.

Notes:
- Write operation; always require explicit user approval in the chat UI.
- If the user is already removed or cannot be found, return an error so the user can verify member list again.`;
